import { css, styled } from 'styled-components';

import { rem } from '@desygner/ui-common-components';

export const StyledVolumeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => rem(theme.Spacing.Type.Section)};
  padding-right: ${({ theme }) => rem(theme.Spacing.Type.Section)};
  width: ${rem(120)};
  ${({ theme }) => css`
    @media (min-width: ${theme.Screen.Size.Medium}px) {
      width: ${rem(150)};
    }
  `};
`;
